import React, { useState } from 'react';
import { connect } from 'react-redux';
import classNames from 'classnames/bind';
import styles from './index.pcss';
import FacetFilterModal from './Modals/FacetFilterModal';
import { RootState } from '../../../../../types/rootState';
import { getLuxeFlags } from '../../../../../../Flags/selectors';
import { getCurrentStore } from '../../../../../selectors/metaData';
import { getPlpOnLandingConfig } from '../../../../../selectors/featureFlagsSelector';
import { getPlpOnLandingEnabled } from '../../../../../selectors/featureFlagsSelector';
import { getPlpOnLandingTitleEnabled } from '../../../../../selectors/featureFlagsSelector';
import { getFilterTabsOnLandingEnabled } from '../../../../../selectors/featureFlagsSelector';
import { getPriorityDeliveryConfig } from '../../../../../selectors/featureFlagsSelector';
import { getPriorityDeliverySLPTagsConfig } from '../../../../../selectors/featureFlagsSelector';
import { getAjiogramInterventionsConfig } from '../../../../../selectors/featureFlagsSelector';
import SortFilterModal from './Modals/SortFilterModal';

const cx = classNames.bind(styles);
import CategoryFacetFilterModal from './Modals/CategoryFacetFilterModal';

const Filters = props => {
  const {
    addressBook,
    pushToHistory = () => {},
    fetchNextFacets,
    replaceInHistory,
    selectedFilterTabCode,
    toggleFilterModal,
    updateFilterTabsCount,
    handleFilterResetGAEvent,
    handleFilterSortApplyGAEvent,
    is_GA4,
    displayFilterModal = false,
    facets = {},
    sorts = [],
    setDisplayFilterModal = () => {},
    applyFilter = () => {},
    displaySortModal = false,
    setDisplaySortModal = () => {},
    displayOtherFilterModal = false,
    setDisplayOtherFilterModal = () => {},
    updateSortBy = () => {},
    toggleSortModal = () => {},
    getFiltersApplied = () => {},
    setSelectedSort = () => {},
  } = props;

  const [showNoProducts, setShowNoProducts] = useState(false);

  const handleNoProductsFound = () => {
    setShowNoProducts(true);
    setTimeout(() => setShowNoProducts(false), 3000);
  };

  const handleOpenMainFilterModal = () => {
    setDisplayOtherFilterModal(false);
    window.location.hash = 'filterBy';
    setDisplayFilterModal(true);
  };

  return (
    <div>
      {showNoProducts && (
        <div className={cx('no-products-toast')}>
          No product found for this filter.
        </div>
      )}
      {/* {displaySortModal && (
        <SortFilterModal
          sorts={sorts}
          pushToHistory={() => {}}
          getFiltersApplied={getFiltersApplied}
          visibility={displaySortModal}
          sortByName={setSelectedSort}
          showHideSortModal={setDisplaySortModal}
          clickedFilterTabCode={""}
          handleFilterSortApplyGAEvent={handleFilterSortApplyGAEvent}
          is_GA4={is_GA4}
        />
      )} */}
      {displayOtherFilterModal && (
        <CategoryFacetFilterModal
          pushToHistory={pushToHistory}
          fetchNextFacets={fetchNextFacets}
          replaceInHistory={replaceInHistory}
          categoryModal={displayOtherFilterModal}
          clickedFilterTabCode={selectedFilterTabCode}
          switchToAllFilter={handleOpenMainFilterModal}
          updateCategoryModal={setDisplayOtherFilterModal}
          updateFilterTabsCount={() => {}}
          handleFilterResetGAEvent={() => {}}
          handleFilterSortApplyGAEvent={() => {}}
          is_GA4={is_GA4}
          plpOnLandingData={{}}
          facets={facets}
          applyFilter={applyFilter}
          isFromPopup
          onNoProductsFound={handleNoProductsFound}
        />
      )}
    </div>
  );
};

const mapStateToProps = (state: RootState) => {
  const { addressBook = {} } = state;

  return {
    luxeFlags: getLuxeFlags(state?.flags),
    currentStore: getCurrentStore(state),
    plpOnLandingConfig: getPlpOnLandingConfig(state),
    isPlpOnLandingEnabled: getPlpOnLandingEnabled(state),
    isPlpOnLandingTitleEnabled: getPlpOnLandingTitleEnabled(state),
    isFilterTabsOnLandingEnabled: getFilterTabsOnLandingEnabled(state),
    priorityDeliveryConfig: getPriorityDeliveryConfig(state),
    priorityDeliverySLPTagsConfig: getPriorityDeliverySLPTagsConfig(state),
    ajiogramInterventionsConfig: getAjiogramInterventionsConfig(state?.flags),
    addressBook
  };
};

export default connect(mapStateToProps)(Filters);
